import { useState } from "react";
import { Menu } from "antd";
import {
  CopyrightOutlined,
  ContainerOutlined,
  FormatPainterOutlined,
  FileProtectOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import colors from "constants/palette";
import {
  Brands,
  Categories,
  Themes,
  Information,
  Banners,
} from "./SetttingPages";
import { GlassCard } from "components/App/styled";

export default function SettingsPage() {
  const [page, setPage] = useState(window.innerWidth > 720 ? "0" : false);
  const handleCancel = () => {
    setPage(false);
  };
  console.log(page);
  const items = [
    {
      title: "برند ها",
      icon: <CopyrightOutlined />,
      page: <Brands returnPage={handleCancel} />,
    },
    {
      title: "دسته بندی ها",
      icon: <ContainerOutlined />,
      page: <Categories returnPage={handleCancel} />,
    },
    {
      title: "اطلاعات وبسایت",
      icon: <FileProtectOutlined />,
      page: <Information returnPage={handleCancel} />,
    },
    {
      title: "بنر ها",
      icon: <PictureOutlined />,
      page: <Banners returnPage={handleCancel} />,
    },
    // {
    //   title: "مشتریان",
    //   icon: <TeamOutlined />,
    //   page: <Customers returnPage={handleCancel} />,
    // },
    // {
    //   title: "مدیریت کاربران",
    //   icon: <TeamOutlined />,
    //   page: <Users returnPage={handleCancel} />,
    // },
    // {
    //   title: "مدیریت تارگت ها",
    //   icon: <RocketOutlined />,
    //   page: <Targets returnPage={handleCancel} />,
    // },
    {
      title: "پوسته ها",
      icon: <FormatPainterOutlined />,
      page: <Themes returnPage={handleCancel} />,
    },
  ];
  if (!true) {
    return;
  }
  return (
    <Container notActive={window.innerWidth < 720 && page ? "true" : null}>
      <StyledMenu
        selectedKeys={page}
        mode={"inline"}
        onSelect={(e) => setPage(e.key)}
      >
        {items.map((item, key) => (
          <Menu.Item icon={item.icon} key={key}>
            {item.title}
          </Menu.Item>
        ))}

        {/* <Menu.Item key="link" icon={<LinkOutlined />}>
          <a
            href="https://ant.design"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ant Design
          </a>
        </Menu.Item> */}
      </StyledMenu>
      <Content>{page && items[page].page}</Content>
      <MobileContent className={page && "show"}>
        {page && items[page].page}
      </MobileContent>
    </Container>
  );
}
const Container = styled(GlassCard)`
  display: flex;
  position: relative;
  color: ${colors.dark};
  padding: 40px 0;

  background-color: ${({ notActive }) =>
    notActive ? "none" : colors.white + "60"};

  & label,
  div {
    color: ${colors.dark};
  }
  @media (max-width: 720px) {
    flex-direction: column;
  }
`;
const StyledMenu = styled(Menu)`
  color: ${colors.dark};
  background: transparent;
  border-color: ${colors.white + "40"};
  & .ant-menu-item {
    flex-direction: row-reverse;
  }
  & .ant-menu-title-content {
    text-align: right;
  }
  width: 256px;

  transition: all 0.3s ease-in-out;
  opacity: ${({ selectedKeys }) =>
    window.innerWidth < 720 && selectedKeys ? "0" : "1"};

  @media (max-width: 720px) {
    /* @media (max-width: 720px) { */
    width: 100%;
  }
`;
const Content = styled.div`
  margin-right: 32px;
  width: 100%;

  @media (max-width: 720px) {
    display: none;
    margin-right: 0;
  }
`;
const MobileContent = styled.div`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  background: ${colors.white + "50"};
  width: 100%;
  transition: all ease-in-out 0.2s;
  border-radius: 7px;

  opacity: 0;
  @media (max-width: 720px) {
    display: block;
    margin-right: 0;

    &.show {
      opacity: 1;
      padding-bottom: 40vh;
    }
  }
`;
